import { useState } from 'react';

import Box from '@mui/material/Box';
import AddIcon from '@mui/icons-material/Add';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';


// material-ui
import { Button } from '@mui/material';

import DeviceDialog from './DeviceDialog';

const AddDevice = () => {
  const theme = useTheme();  
  const matchDownSM = useMediaQuery(theme.breakpoints.down('sm'));
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Box>
      <Button onClick={handleClickOpen} color={'primary'} variant={'contained'} startIcon={<AddIcon />}>
        {!matchDownSM && 'Add device'}
      </Button>
      <DeviceDialog open={open} isEditMode={false} handleClose={handleClose}></DeviceDialog>
    </Box>
  );
};

export default AddDevice;
